// extracted by mini-css-extract-plugin
export default {"content":"index_content_g5x8f","replyUser":"index_replyUser_e7b9P"};